import {subDays, subMonths, startOfMonth, endOfMonth, startOfYear} from 'date-fns'

export const PAGE_ROUTES = ['/login', '/register', '/retrieve-password', '/manager-login'];

export const RE = {
  // 特殊字符（小数点除外）
  specialExceptPoint: /[` ~!@#$%^&*()+=<>?:"{},\\/;'[\]·！￥（）：；“”‘、，|《。》？【】]/im,
  // 特殊字符
  special: /[` ~!@#$%^&*()+=<>?:"{},.\\/;'[\]·！￥（）：；“”‘、，|《。》？【】]/im,
  // 0或负整数
  ng0: /(^-?[0-9]$)|(^-?[1-9][0-9]+$)/,
  // 0或正整数
  pt0: /(^[0-9]$)|(^[1-9][0-9]+$)/,
  // 正整数
  pt: /^[1-9][0-9]*$/,
  // 手机号码
  phone: /^[1][3,4,5,7,8][0-9]{9}$/,
  // 数量
  num: (num = 2) => {
    if (num === 1) {
      // 1位小数
      return /^([0-9]|[1-9][0-9]+)(\.\d)?$/;
    }
    // TODO: 实现数值传入，实现数值变化
    // 两位小数
    if (num === 4) {
      return /^([0-9]|[1-9][0-9]+)(\.\d{1,4})?$/;
    }
    return /^([0-9]|[1-9][0-9]+)(\.\d{1,2})?$/
  },
  // 税率(保留两位小数)
  rate: /^([0-9]|[1-9][0-9]?|100)(\.\d{1,2})?$/,
};

const today = new Date();
const yesterday = subDays(new Date(), 1);
/**
 * 常用时间段对象
 * @typedef { Object } DATE_SHORTCUTS
 * @property { Object } today - 今天
 * @property { Object } yesterday - 昨天
 * @property { Object } last7Day - 近7天
 * @property { Object } last14Day - 近14天
 * @property { Object } last30Day - 近30天
 * @property { Object } last60Day - 近60天
 * @property { Object } last90Day - 近90天
 * @property { Object } currentMonth - 本月
 * @property { Object } lastMonth - 上月
 * @property { Object } yearToToday - 本年至今
 */
/**
 * @type { DATE_SHORTCUTS } DATE_SHORTCUTS
 */
export const DATE_SHORTCUTS = {
  today: {
    text: '今天',
    date: [today, today],
  },
  yesterday: {
    text: '昨天',
    date: [yesterday, yesterday]
  },
  last7Day: {
    text: '近7天',
    date: [subDays(today, 6), today]
  },
  last14Day: {
    text: '近14天',
    date: [subDays(today, 13), today],
  },
  last30Day: {
    text: '近30天',
    date: [subDays(today, 29), today],
  },
  last60Day: {
    text: '近60天',
    date: [subDays(today, 59), today],
  },
  last90Day: {
    text: '近90天',
    date: [subDays(today, 89), today]
  },
  currentMonth: {
    text: '本月',
    date: [startOfMonth(today), endOfMonth(today)]
  },
  lastMonth: {
    text: '上月',
    date: [startOfMonth(subMonths(today, 1)), endOfMonth(subMonths(today,1))]
  },
  yearToToday: {
    text: '本年至今',
    date: [startOfYear(today), today]
  }
};

export const RESPONSE_CODE = {
  SUCCESS: 0,
  FAIL: -1,
  TIMEOUT: -2
};

export const ASIN_361_MODULE = 'ASIN_361_MODULE'

export const ASIN_361_MODULE_COMPREHENSIVE = 'ASIN_361_MODULE_COMPREHENSIVE'

export const SHOP_WIDE_MODULE = 'SHOP_WIDE_MODULE'

export const ASIN_361_SEARCH_PARAM = 'ASIN_361_SEARCH_PARAM'
/**
 * 去localStorage 读取页面分页的配置标志
 * @returns String
 */
export const CACHE_PAGINATION_PAGESIZE =  function () {
  return `page_${this.$route.path.replace(/\//g, '')}`
}
